export default __webpack_public_path__ + "static/media/tem_no_parque4.176230cb.jpg";